module.exports = __webpack_public_path__ + "static/media/okki-landing-5.a1fe0e26.svg";